<template>
  <v-app>
    <router-view />

    <v-snackbar
      v-model="$store.state.alerts.visible"
      :color="$store.state.alerts.color"
      :timeout="2000"
      top
      fixed
      center
      rounded="pill"
      class="custom-elevation"
    >
      <div class="text-center bold pl-3">
        {{ $store.state.alerts.text }}
      </div>
    </v-snackbar>

    <CookiesModal />

    <YearModal />
  </v-app>
</template>

<style lang="scss">
// Fonts
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;600;700;800&display=swap');

// Global Styles and animations
@import '@/styles/globals.scss';
@import '@/styles/animations.scss';

.v-snack.v-snack--absolute {
  z-index: 99;
}
.v-snack {
  padding-top: 0px !important;
}
// iOS navigation fix
body, .v-toolbar {
  padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-top: env(safe-area-inset-top); /* iOS 11.2 */
}
.v-toolbar {
  height: auto !important;
}
.v-bottom-navigation {
  height: auto !important;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.v-bottom-navigation > * {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}
.v-snack {
  padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-top: env(safe-area-inset-top); /* iOS 11.2 */
}
// .ios .v-snack {
//   padding-top: 56px !important;
// }
// /iOS navigation fix
</style>

<script>
import CookiesModal from '@/components/CookiesModal.vue';
import YearModal from '@/components/form/YearModal.vue';

document.addEventListener('deviceready', (device) => {
  console.log(device);
}, false);

export default {
  name: 'App',
  components: {
    CookiesModal,
    YearModal,
  },
  // data: () => ({}),
};
</script>
